import { render } from "./Header.vue?vue&type=template&id=23ea14ca"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/header/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23ea14ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23ea14ca', __exports__)) {
    api.reload('23ea14ca', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=23ea14ca", () => {
    api.rerender('23ea14ca', render)
  })

}


export default __exports__